import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'

import Root from '../../views/Root.vue'
/**
 * 首页
 */
import Index from '../../views/Index.vue'
import CopyrighterIndex from '../../views/copyrighter/CopyrightIndex.vue'
import AnchorIndex from '../../views/anchor/AnchorIndex.vue'
/* 主播 */
import AnchorHelpCenter from '../../views/anchor/helpCenter/AnchorHelpCenter.vue'
import AnchorAboutPlatForm from '../../views/anchor/helpCenter/AnchorAboutPlatForm.vue'
import BeAnAnchor from '../../views/anchor/helpCenter/BeAnAnchor.vue'
import SearchTask from '../../views/anchor/helpCenter/SearchTask.vue'
import AuditionTips from '../../views/anchor/helpCenter/AuditionTips.vue'
import PickEquipment from '../../views/anchor/helpCenter/PickEquipment.vue'
import AnnounceTips from '../../views/anchor/helpCenter/AnnounceTips.vue'
import AudioPostProgress from '../../views/anchor/helpCenter/AudioPostProgress.vue'
import RecordDemand from '../../views/anchor/helpCenter/RecordDemand.vue'
import AnchorDataAnalysis from '../../views/anchor/helpCenter/DataAnalysis.vue'
import Popularize from '../../views/anchor/helpCenter/Popularize.vue'
import EarningClosing from '../../views/anchor/helpCenter/EarningClosing.vue'
import AnchorLevelTips from '../../views/anchor/helpCenter/AnchorLevelTips.vue'

import AnchorCenterCommon from '../../views/anchor/center/CenterCommon.vue'
import AnchorAuditionTasks from '../../views/anchor/center/AuditionTasks.vue'
import AnchorMyAudioBook from '../../views/anchor/center/MyAudioBook.vue'
import AnchorMyVoiceTag from '../../views/anchor/center/MyVoiceTag.vue'
import AnchorTodo from '../../views/anchor/center/Todo.vue'
/* 版权方 */
import CopyrighterHelpCenter from '../../views/copyrighter/helpCenter/CopyrighterHelpCenter.vue'
import CopyrighterAboutPlatform from '../../views/copyrighter/helpCenter/CopyrighterAboutPlatform.vue'
import HelpCenterCopyrighterSignIn from '../../views/copyrighter/helpCenter/HelpCenterCopyrighterSignIn.vue'
import HelpCenterCopyrightManagement from '../../views/copyrighter/helpCenter/HelpCenterCopyrightManagement.vue'
import HelpCenterTaskManagement from '../../views/copyrighter/helpCenter/HelpCenterTaskManagement.vue'

import CopyrighterCenter from '../../views/copyrighter/center/Center.vue'
import WorksManagement from '../../views/copyrighter/center/WorksManagement.vue'
import DataAnalysis from '../../views/copyrighter/center/DataAnalysis.vue'
import UploadCopyright from '../../views/copyrighter/UploadCopyright.vue'
import WorkProgress from '../../views/copyrighter/center/WorkProgress.vue'
import BookDetail from '../../views/copyrighter/center/BookDetail.vue'
import Messages from '../../views/copyrighter/center/Messages.vue'
import WriterCenterEvents from '../../views/copyrighter/center/Events.vue'
import InnerEnterGuiding from '../../views/copyrighter/center/InnerEnterGuiding.vue'
import Apply from '../../views/copyrighter/Apply.vue'
import ApplyWaiting from '../../views/copyrighter/ApplyWaiting.vue'

import BaseInfo from '../../views/copyrighter/publishTask/BaseInfo.vue'
/* 任务管理*/
import TaskManagementList from '../../views/copyrighter/taskManagement/TaskManagementList.vue';
import TaskDetailsMass from '../../views/copyrighter/taskManagement/TaskDetailsMass.vue';
import TaskDetailsMaking from '../../views/copyrighter/taskManagement/TaskDetailsMaking.vue';
/* 支付 */
import ToPayPage from '../../views/copyrighter/pay/ToPayPage.vue'
import PayResultConfirm from '../../views/copyrighter/pay/PayResultConfirm.vue'
/* 公共组件*/
import Announcement from '../../views/components/Announcement.vue'
/* 推广活动 */
import Idols from '../../views/popularize/Idols.vue'
import Classic from '../../views/popularize/Classic.vue'
import WorkLib from '../../views/popularize/WorkLib.vue'
import Benefits from '../../views/popularize/Benefits.vue'
/* 专题活动 */
import SpecialTopicDetail from '../../views/specialTopic/Detail.vue'
import SpecialTopicList from '../../views/specialTopic/List.vue'
import FastMissionIntro from '../../views/specialTopic/FastMissionIntro.vue'



Vue.use(VueRouter)
const base = store.state.BASE_PATH
// const rootPath = '/xjk'
const rootPath = '';
const router = new VueRouter({
  base,
  mode: 'history',
  scrollBehavior (to, form, savedPosition) {
    if(to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes: [
    /**
     * 首页
     */
    {
      path: rootPath + '/',
      name: '/',
      component: Index
    },
    {
      path: rootPath + '/anchorIndex',
      name: 'anchorIndex',
      component: AnchorIndex
    },
    {
      path: rootPath + '/copyrighterIndex',
      name: 'copyrighterIndex',
      component: CopyrighterIndex
    },
    {
      name: 'copyrighterApply',
      path: rootPath + '/copyrighter/apply',
      component: Apply
    },
    {
      name: 'copyrighterApplyWaiting',
      path: rootPath + '/copyrighter/apply/waiting',
      component: ApplyWaiting
    },
    {
      name: 'specialTopicDetail',
      path: rootPath + '/specialtopic/detail/:id',
      component: SpecialTopicDetail
    },
    {
      name: 'specialTopicList',
      path: rootPath + '/specialtopic/list',
      component: SpecialTopicList
    },
    {
      name: 'fastMissionIntro',
      path: rootPath + '/specialtopic/fastmissionintro',
      component: FastMissionIntro
    },
    {
      name: 'copyrighter',
      path: rootPath + '/copyrighter',
      beforeEnter: (to, from, next) => {
        if (!store.state.user.login) {
          store.dispatch('getUser').then(() => {
            store.dispatch('getStatus').then(() => {
              if (!store.state.user.login) {
                location.href = store.state.LOGIN_URL+'?fromUrl='+to.fullPath;
              } else {
                // 版权方工作台权限
                if (!store.state.user.author.authorProgressStatus)  {
                  next({name: 'copyrighterApply'})
                } else {
                  next();
                }
              }
            }, () => {
              // 没有版权方信息
              next({name: 'copyrighterApply'})
            });
          }, () => {
            location.href = store.state.LOGIN_URL+'?fromUrl='+to.fullPath;
          });
        } else {
          // 版权方工作台权限
          if (!store.state.user.author.authorProgressStatus)  {
            next({name: 'copyrighterApply'})
          } else {
            next();
          }
        }
      },
      component: Root,
      children: [
        {
          name: 'uploadCopyright',
          path: 'uploadcopyright',
          component: UploadCopyright
        },
        {
          name: 'CopyrighterCenter',
          path: 'center',
          component: CopyrighterCenter,
          children: [
            {
              name: 'innerEnterGuiding',
              path: 'innerenterguiding',
              component: InnerEnterGuiding
            },
            {
              name: 'worksManagement',
              path: 'worksmanagement',
              component: WorksManagement
            },
            {
              name: 'dataAnalysis',
              path: 'dataanalysis',
              component: DataAnalysis
            },
            {
              name: 'workProgress',
              path: 'workprogress/:id',
              component: WorkProgress
            },
            {
              name: 'copyrighterMessage',
              path: 'messages',
              component: Messages
            },
            {
              name: 'bookDetail',
              path: 'bookdetail/:id',
              component: BookDetail
            },
            {
              name: 'WriterCenterEvents',
              path: 'events',
              component: WriterCenterEvents
            },
            {
              name: 'taskManagementList',
              path: 'taskmanagementlist',
              component: TaskManagementList
            },
            {
              name: 'taskDetailsMass',
              path: 'taskdetailsmass/:id',
              component: TaskDetailsMass
            },
            {
              name: 'taskDetailsMaking',
              path: 'taskdetailsmaking/:id',
              component: TaskDetailsMaking
            },
            {
              name: 'copyrighterAnnouncement',
              path: 'announcement',
              component: Announcement
            }
          ]
        },
        {
          name: 'baseInfo',
          path: 'publish/task/baseInfo',
          component: BaseInfo
        },
        {
          name: 'toPayPage',
          path: 'pay/topaypage/:requirementId',
          component: ToPayPage
        },
        {
          name: 'payResultConfirm',
          path: 'pay/payresultconfirm/:requirementId',
          component: PayResultConfirm
        }
      ]
    },
    {
      name: 'anchorCenter',
      path: rootPath + '/anchor/center',
      component: AnchorCenterCommon,
      redirect: {name: 'anchorAuditionTasks'},
      beforeEnter: (to, from, next) => {
        if (!store.state.user.login) {
          store.dispatch('getUser').then(() => {
            if (!store.state.user.login) {
              location.href = store.state.LOGIN_URL+'?fromUrl='+to.fullPath;
            } else {
              // 主播等级权限
              if (store.state.user.anchor.level < 0)  {
                location.href = store.state.ANCHOR_AUTH_URL;
              } else {
                next();
              }
            }
          }, () => {
            location.href = store.state.LOGIN_URL+'?fromUrl='+to.fullPath;
          });
        } else {
          // 主播等级权限
          if (store.state.user.anchor.level < 0)  {
            location.href = store.state.ANCHOR_AUTH_URL;
          } else {
            next();
          }
        }
      },
      children: [
        {
          name: 'anchorAuditionTasks',
          path: 'audition/tasks',
          component: AnchorAuditionTasks
        },
        {
          name: 'anchorMyAudioBook',
          path: 'my/audio/book',
          component: AnchorMyAudioBook
        },
        {
          name: 'anchorMyVoiceTag',
          path: 'my/voice/tag',
          component: AnchorMyVoiceTag
        },
        {
          name: 'anchorMessage',
          path: 'messages',
          component: Messages
        },
        {
          name: 'anchorAnnouncement',
          path: 'announcement',
          component: Announcement
        },
        {
          name: 'anchorTodo',
          path: 'todo',
          component: AnchorTodo
        }
      ]
    },
    {
      name: 'copyrighterHelpCenter',
      path: rootPath + '/copyrighter/help/center',
      component: CopyrighterHelpCenter,
      redirect: {name: 'copyrighterAboutPlatform'},
      children: [
        {
          name: 'copyrighterAboutPlatform',
          path: 'aboutPlatform',
          component: CopyrighterAboutPlatform
        },
        {
          name: 'helpCenterCopyrighterSignIn',
          path: 'signIn',
          component: HelpCenterCopyrighterSignIn
        },
        {
          name: 'helpCenterCopyrightManagement',
          path: 'copyrightManagement',
          component: HelpCenterCopyrightManagement
        },
        {
          name: 'helpCenterTaskManagement',
          path: 'taskManagement',
          component: HelpCenterTaskManagement
        }
      ]
    },
    {
      name: 'anchorHelpCenter',
      path: rootPath + '/anchor/help/center',
      component: AnchorHelpCenter,
      redirect: {name: 'anchorAboutPlatform'},
      children: [
        {
        name: 'anchorAboutPlatform',
        path: 'aboutPlatform',
        component: AnchorAboutPlatForm
        },
        {
          path: 'beAnAnchor',
          name: 'beAnAnchor',
          component: BeAnAnchor
        },
        {
          path: 'searchTask',
          name: 'searchTask',
          component: SearchTask
        },
        {
          path: 'auditionTips',
          name: 'auditionTips',
          component: AuditionTips
        },
        {
          path: 'recordDemand',
          name: 'recordDemand',
          component: RecordDemand
        },
        {
          path: 'anchorDataAnalysis',
          name: 'anchorDataAnalysis',
          component: AnchorDataAnalysis
        },
        {
          path: 'popularize',
          name: 'popularize',
          component: Popularize
        },
        {
          path: 'earningClosing',
          name: 'earningClosing',
          component: EarningClosing
        },
        {
          path: 'pickEquipment',
          name: 'pickEquipment',
          component: PickEquipment
        },
        {
          path: 'audioPostProgress',
          name: 'audioPostProgress',
          component: AudioPostProgress
        },
        {
          path: 'announceTips',
          name: 'announceTips',
          component: AnnounceTips
        },
        {
          path: 'anchorLevelTips',
          name: 'anchorLevelTips',
          component: AnchorLevelTips
        }
      ]
    },
    {
      name: 'idols',
      path: rootPath + '/popularize/idols',
      component: Idols
    },
    {
      name: 'classic',
      path: rootPath + '/popularize/classic',
      component: Classic
    },
    {
      name: 'workLib',
      path: rootPath + '/popularize/worklib',
      component: WorkLib
    },
    {
      name: 'benefits',
      path: rootPath + '/popularize/benefits',
      component: Benefits
    }
  ]
})
/**
 * [PAGE_TITLE 添加页面title]
 * @type {Object}
 */
const PAGE_TITLE = {
  '/': '有声化平台',
  'writerapply': '作家基本信息',
  'applybookinfo': '作家作品信息'
}

export {PAGE_TITLE, router}



// WEBPACK FOOTER //
// ./src/router/index.js